import axios from 'axios';
import 'url-search-params-polyfill';
import {CONFIG_ENV} from '@/config';
import {TCategory} from "@/types/TCategory";

type TOptionCategory={
    pid: string,
    lantHierarchyCategories:string,
    withLength:string,
    withWidth:string,
    withThickness:string,
    withDiameter:string
}

interface TAjaxResponseSimple {
    status: string;
    message: string;
}

type TAjaxResponseGetCategory= {
    status: string;
    message: string;
    category:TCategory&{parent_name:string}&{hasChilds:string};
}

interface TAjaxResponseGetNomCategory {
    status: string;
    message: string;
    treeDataCategories:TCategory[];
}

interface TAjaxResponseGetNomCategoryList {
    status: string;
    message: string;
    listDataCategories:TOptionCategory[];
}

export class ServiceAdminNomCategory {
    public static async getNomCategoryTreeData(): Promise<TAjaxResponseGetNomCategory> {
        const rnd=Math.random();
        const response = await axios.get(`${CONFIG_ENV.URL_ADMIN.treeDataCategories}/${rnd}`);
        return response.data;
    }

    public static async getNomCategorylistData(): Promise<TAjaxResponseGetNomCategoryList> {
        const rnd=Math.random();
        const response = await axios.get(`${CONFIG_ENV.URL_ADMIN.listDataCategories}/${rnd}`);
        return response.data;
    }

    public static async postCategory(pcategory: TCategory&{img:any|null}): Promise<TAjaxResponseSimple> {
        const param = new FormData(); //Create a form object
        param.append('file', pcategory.img);//Add data to the form object via append
        param.append('pid', pcategory.pid);
        param.append('parent_pid', pcategory.parent_pid);
        param.append('name', pcategory.name);
        param.append('with_length', pcategory.withLength);
        param.append('with_width', pcategory.withWidth);
        param.append('with_thickness', pcategory.withThickness);
        param.append('with_diameter', pcategory.withDiameter);
        param.append('is_parent_for_articles', pcategory.is_parent_for_articles);
        const config = {
            headers: {'Content-Type': 'multipart/form-data'}
        };
        //const params = new URLSearchParams();
        //params.set('name', pcategory.name);
        //params.set('img', pcategory.img);
        let response;
        if(pcategory.pid){
            response = await axios.post(`${CONFIG_ENV.URL_ADMIN.nomCategory}/${pcategory.pid}`, param, config);
        }else{
            response = await axios.post(`${CONFIG_ENV.URL_ADMIN.nomCategory}`, param, config);
        }

        return response.data;
    }

    public static async deleteCategory(pid:string): Promise<TAjaxResponseSimple> {
        const response = await axios.delete(`${CONFIG_ENV.URL_ADMIN.nomCategory}/${pid}`);
        return response.data;
    }

    public static async getCategory(pid:string): Promise<TAjaxResponseGetCategory> {
        const response = await axios.get(`${CONFIG_ENV.URL_ADMIN.nomCategory}/${pid}`);
        return response.data;
    }

    public static async getImageCategoryAsString(pid:string): Promise<string> {
        const response = await axios.get(`${CONFIG_ENV.URL_ADMIN.imageCategoryAsString}/${pid}`);
        return response.data;
    }

    public static async getProfileImgAsString(puserappid:string) {
        const res = await  <Promise<string>>  axios.get(`${CONFIG_ENV.URL_USER.getMyImageProfileAsString}/${puserappid}`);
        return res;
    }
}
